import React from "react";
import useGlobalStore from "../stores/globalStore";

export default function ResetFormButton() {
  //Stores
  const {
    resetSelectedNetwork,
    resetSelectedBroadband,
    resetSelectedBroadbandEquipment,
    resetSelectedTvEquipment,
    resetSelectedSecurity,
    resetSelectedTvBasePackage,
    resetSelectedTvPackage,
    resetSelectedFlexChannels,
    unsetDigiCardAmount,
    updateActiveView,
    resetForm,
  } = useGlobalStore((state) => state);

  //Functions
  const handleResetForm = () => {
    resetSelectedNetwork();
    resetSelectedBroadband();
    resetSelectedBroadbandEquipment();
    resetSelectedTvEquipment();
    resetSelectedSecurity();
    resetSelectedTvBasePackage();
    resetSelectedTvPackage();
    resetSelectedFlexChannels();
    unsetDigiCardAmount();

    resetForm();

    updateActiveView(1);
  };

  return (
    <button type="button" className="tel-pt-reset-button" onClick={() => handleResetForm()}>
      Börja om
    </button>
  );
}
